import EFPicture from '@elem/compCommon/EFPicture';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';

export default function D() {
    const { useLang, Link } = useGlobal();
    const { t } = useLang('vanlife');
    const items: any[] = [
        {
            title: t('secD_item1_title'),
            desc: t('secD_item1_desc'),
        },
        {
            title: t('secD_item2_title'),
            desc: t('secD_item2_desc'),
        },
        {
            title: t('secD_item3_title'),
            desc: t('secD_item3_desc'),
        },
        {
            title: t('secD_item4_title'),
            desc: t('secD_item4_desc'),
        },
    ];
    return (
        <div id="vanlife-D" className={`vanlife-D ${css['vanlife-D']}`}>
            <h2 className="title">{t('secD_title')}</h2>
            <div className="img-box">
                <EFPicture src={'/responsive/picture/vanlife/4.jpg'} alt={t('secD_title')} />
            </div>
            <p className="text">{t('secD_desc')}</p>
            <ul className="items">
                {items?.map((item: any, k: number) => (
                    <li id={`vanlife-D-${k + 1}`} className="item" key={k}>
                        <h3 className="item-title">{item.title}</h3>
                        <p className="item-desc text">{item.desc}</p>
                    </li>
                ))}
            </ul>
        </div>
    );
}
